export default {"src":"/_next/static/media/icon-social-glassdoor-white.5589fd18.svg","height":23,"width":16};